import NiceModal, {useModal} from '@ebay/nice-modal-react';
import {Observer} from 'mobx-react';

import {useI18n} from '@yourcoach/i18n';
import {alert} from '@yourcoach/shared/components/alert';
import {
  RequestRefundContainer,
  RequestRefundStore,
} from '@yourcoach/shared/modules/request-refund';
import {isCancelCommand} from '@yourcoach/shared/services/entity-action/utils';
import {LoadingSpinner} from '@yourcoach/shared/uikit/LoadingSpinner';
import {logger} from '@yourcoach/shared/utils/logger';
import {useMobxStore} from '@yourcoach/shared/utils/store';

import * as S from './styles';

type Props = {
  courseId: string;
};

export const RequestRefundModal = NiceModal.create<Props>(({courseId}) => {
  const {t} = useI18n();
  const modal = useModal();
  const requestRefundStore = useMobxStore(
    () => new RequestRefundStore(courseId),
  );

  const handleSubmit = async () => {
    try {
      const result = await requestRefundStore.requestRefund();

      if (isCancelCommand(result)) {
        return;
      }

      modal.hide();
    } catch (e) {
      logger.error(e);

      alert.error(e);
    }
  };

  return (
    <S.Modal
      bodyClassName="body"
      isOpen={modal.visible}
      onAfterClose={modal.remove}
      onRequestClose={modal.hide}
      title={t('shared:request_refund')}
    >
      <RequestRefundContainer store={requestRefundStore} />
      <S.ButtonsContainer>
        <S.FooterButton onClick={modal.hide} scheme="gray" size="l">
          {t('shared:close')}
        </S.FooterButton>
        <S.FooterButton onClick={handleSubmit} scheme="primary" size="l">
          {t('shared:send_request')}
        </S.FooterButton>
      </S.ButtonsContainer>
      <Observer>
        {() =>
          requestRefundStore.isFetching ||
          requestRefundStore.isRequestRefundInProcess ? (
            <div className="overlay">
              <LoadingSpinner />
            </div>
          ) : null
        }
      </Observer>
    </S.Modal>
  );
});
